import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AcademyCommonModule } from '@draeger-academy/common';
import { AcademyPresentationUiModule } from '@draeger-academy/presentation';
import { DetailsModule } from './modules/details/details.module';
import { IframeComponent } from './modules/iframe/iframe.component';
import { PortalHomeComponent } from './modules/portal-home/portal-home.component';
import { PortalLegalPageComponent } from './modules/portal-legal-page/portal-legal-page.component';
import { PartnerPortalComponent } from './partner-portal.component';
import { PortalBookingErrorComponent } from './modules/portal-booking-error/portal-booking-error.component';

@NgModule({
    declarations: [PartnerPortalComponent, IframeComponent, PortalLegalPageComponent, PortalHomeComponent, PortalBookingErrorComponent],
    imports: [
        CommonModule,
        AcademyCommonModule,
        AcademyPresentationUiModule,
        DetailsModule
        //please do not change the order of the next 3 imports
    ],
    providers: [],
    exports: [PartnerPortalComponent, IframeComponent, PortalLegalPageComponent, PortalHomeComponent, PortalBookingErrorComponent]
})
export class PartnerPortalModule {}
